// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"7071b632","410":"7071b632","426":"7071b632","622":"b5f6f9bf"}[chunkId] + ".chunk.css";
};